import moment from 'moment'

const getFormatDate = value => (value ? moment(value, 'YYYY-MM-DD').format('MM/DD/YYYY') : '')
const setFormatDate = value => moment(value, 'MM/DD/YYYY').format('YYYY-MM-DD')

export {
  getFormatDate,
  setFormatDate,
}
